export const getCookiePolicyFromStorage = (): string | null => localStorage.getItem('cookiePolicy');
